import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { NotificationsComponent } from './../../../../resources/components/notifications/notifications.component';
import { DSesionServicios, DConfigCuentaUsuarioTO, DOperCtaUsuarioTO, DDatosPwdTO, DRtaCuentaUsuarioTO, DUsuarioCuentaTO } from '@dian-api/api-sesion';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-autenticacion',
  templateUrl: './autenticacion.component.html',
  styleUrls: ['./autenticacion.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ DatePipe, DSesionServicios ]
})
export class AutenticacionComponent implements OnInit {
	
  public loading: boolean = false;
  public invalidNumDoc: boolean = false;
  public invalidDate: boolean = false;
  public validacionRecaptcha: boolean = false;
  public requireCaptcha: boolean = false; 
  public cuentaModel: DDatosPwdTO;
  public usuarioModel: DUsuarioCuentaTO;
  keyCaptcha = environment.captchaKeyCloudflare;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private _rest: DSesionServicios,
    private datePipe: DatePipe
  ) {
    this.cuentaModel = new DDatosPwdTO();   
    this.usuarioModel = new DUsuarioCuentaTO();
    this.usuarioModel.persona.tipoDocumento = "";
  }

  ngOnInit() {    
    localStorage.removeItem('identificacion');
    localStorage.removeItem('medios-comunicacion');
  } 

  onCaptchaSuccess(token: string) {
    if (token) this.validacionRecaptcha = true;
  }

  // onScriptLoad() {
  //   console.log('Google reCAPTCHA loaded and is ready for use!');
  // }
 
  // onScriptError() {
  //   console.log('Something went long when loading the Google reCAPTCHA')
  //   this.validacionRecaptcha = false;
  // }

  validateNumDoc() {
    if (!this.usuarioModel.persona.numDocumento) return;
    const specialChars = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    const onlyNumers = ['RC', 'TI','CC','CR','TE','CD', 'CE', 'PEP', 'PPT'];
    this.invalidNumDoc = specialChars.test(this.usuarioModel.persona.numDocumento);
    if (onlyNumers.indexOf(this.usuarioModel.persona.tipoDocumento) > -1) 
      this.invalidNumDoc = !(/^\d+$/).test(this.usuarioModel.persona.numDocumento);            
  }

  validateDate(date: string) {
    if (!date) return;
    const formatDate = /^\d{4}[./-]\d{2}[./-]\d{2}$/;
    this.invalidDate = !formatDate.test(date);
  }

  public submmit() { 
    if (!this.validacionRecaptcha) {
      this.showError('', 'No se pudo superar el captcha.');
      return;
    }

    this.loading = true;   
    this.usuarioModel.persona.fechaExpedicionDoc = this.datePipe.transform(this.usuarioModel.persona.fechaExpedicionDoc, 'yyyy-MM-dd')
    const modelOperacion: DOperCtaUsuarioTO = new DOperCtaUsuarioTO();      
    const model: DConfigCuentaUsuarioTO = new DConfigCuentaUsuarioTO();    
    modelOperacion.codigo = "1";
    model.operacion = modelOperacion;
    model.usuariocuenta = this.usuarioModel;

          
    this._rest.habilitarCuentaUsuario(model)
      .subscribe(
        res => { 
          this.loading = false;    
          const respuesta = <DRtaCuentaUsuarioTO>res; 

          //Error desconocido o Usuario no existe
          if (respuesta.codigoRta.tipoRta === "2") {
            this.showError('', 'Datos incorrectos o no encontrados. Verifique e intente de nuevo.');
            return;
          }

          //Usuario ya tiene cuenta habilitada
          if (respuesta.codigoRta.tipoRta === "3") {
            let config = {
              disableClose: true,
              maxWidth: 400,
              data: {
                type: 'peligro',
                title: 'Ya tiene cuenta habilitada',
                message: `Inicie sesión con su usuario y contraseña <a href="#" class="link" [routerLink]="['/login']">aquí</a>`,
                textButton: '',
                valueButton: '',
                classWrap: 'alert alert-primary'
              }              
            };
            this.dialog.open(NotificationsComponent, config);  
            return;
          }
          
          //Success
          if (respuesta.codigoRta.tipoRta === "1") {
            localStorage.setItem('identificacion', JSON.stringify(model));
            if(respuesta.codigoRta.datos.mediosRecuperacion.length > 0 && respuesta.codigoRta.datos.tieneRut == "true"){

              let config = {
                disableClose: true,
                maxWidth: 400,
                data: {
                  type: 'warning',
                  title: '',
                  message: `<p>Al crear la contraseña de su cuenta se generará la Firma Electrónica con la cual podrá gestionar sus trámites de manera virtual, sin necesidad de imprimir ni desplazarse a una entidad bancaria.</p> <p style="margin-top: 15px">La contraseña creada le servirá para ingresar y como Firma Electrónica, que a partir de ahora es obligatoria para autenticar documentos.</p>`,//error.mensaje,
                  textButton: 'Crear contraseña y generar firma',
                  valueButton: 'ok',
                  hideClose: true
                }
              };
              let dialogRef = this.dialog.open(NotificationsComponent, config);  
              dialogRef.afterClosed().subscribe(result => {
                if(result == "ok"){
                  localStorage.setItem('medios-comunicacion', JSON.stringify(respuesta.codigoRta.datos.mediosRecuperacion));
                  this.router.navigate(['/habilitar-cuenta/menu']);
                 
                }
              });
            }else if(respuesta.codigoRta.datos.mediosRecuperacion.length == 0 && respuesta.codigoRta.datos.tieneRut == "false"){
              this.router.navigate(['/habilitar-cuenta/cambiar-pass']);
            }else if(respuesta.codigoRta.datos.mediosRecuperacion.length == 0 && respuesta.codigoRta.datos.tieneRut == "true"){
              let config = {
                disableClose: true,
                maxWidth: 400,
                data: {
                  type: 'error',
                  title: '',
                  message: `No hemos encontrado datos de contacto asociados a su cuenta. Conozca como solucionarlo <a href="https://www.dian.gov.co/atencionciudadano/Agendamiento-de-Citas/Paginas/Inicio.aspx" class="link">aquí</a>.`,
                  textButton: '',
                  valueButton: '',
                  classWrap: 'alert alert-primary'
                }              
              };
              this.dialog.open(NotificationsComponent, config);  
              return;
            }

            
          }                 
        },
        error => {            
          this.loading = false;
          this.showError('', 'Discúlpenos, intente de nuevo', 'Entendido');                    
        }
      );
  }

  private showError(title: string = "", mensaje: string = "", textButton: string = "") {
    let config = {
      disableClose: true,
      maxWidth: 400,
      data: {
        type: 'error',
        title: title,
        message: mensaje,
        textButton: textButton,
        valueButton: '',
        classWrap: 'alert alert-error'
      }              
    };
    this.dialog.open(NotificationsComponent, config);    
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/habilitar-cuenta/components/autenticacion/autenticacion.component.ts